module.exports = __webpack_public_path__ + "static/media/profile.41858120.svg";